module.exports = __webpack_public_path__ + "img/Menu-12.470d8bc7.webp";